import { createContext, useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions, QueryClient } from '@tanstack/react-query';

export const WorkspaceVisibility = createContext(true);
export const useWorkspaceVisible = () => useContext(WorkspaceVisibility);

// Retain React/Ant Design state without tearing down dialog imperative refs. Hidden
// pages unsubscribe from queries, including polling; active pages use normal cache rules.
export const useWorkspaceQuery: typeof useQuery = ((options: UseQueryOptions, client?: QueryClient) => {
  const visible = useWorkspaceVisible();
  return useQuery({ ...options, subscribed: visible && options.subscribed !== false }, client);
}) as typeof useQuery;
